<template>
  <div id="grants-page">
    <HeaderComponent />

    <section class="ministry-block">
      <v-container class="block-container">
        <div class="ministry-grid">
          <div class="ministry-text">
            <span class="ministry-eyebrow">{{ $t('grants.header.eyebrow') }}</span>
            <h2>{{ $t('grants.ministry.title') }}</h2>
            <p>{{ $t('grants.ministry.description') }}</p>
          </div>

          <div class="ministry-logo">
            <img :src="logo" alt="Ministerstwo Nauki i Szkolnictwa Wyższego" />
          </div>
        </div>
      </v-container>
    </section>

    <CompletedProjectSection />
  </div>
</template>

<script>
import HeaderComponent from '@/components/GrantsPage/HeaderComponent'
import CompletedProjectSection from '@/components/GrantsPage/CompletedProjectSection'

export default {
  name: 'GrantsContentComponent',
  components: {
    HeaderComponent,
    CompletedProjectSection
  },
  data() {
    return {
      logo: require('@/assets/img/components/partners/logo/mnisw.webp')
    }
  }
}
</script>

<style lang="sass" scoped>
  #grants-page
    background: #ffffff
    color: #0a0828

  .ministry-block
    background: #0a0828
    color: #fff
    padding: 100px 0
    font-family: Inter, sans-serif

  .block-container
    max-width: 1280px !important
    padding: 0 56px !important

  .ministry-grid
    display: grid
    grid-template-columns: 1.4fr 1fr
    gap: 80px
    align-items: center

  .ministry-eyebrow
    display: block
    font-size: 11px
    font-weight: 600
    letter-spacing: 0.22em
    text-transform: uppercase
    color: rgba(255, 255, 255, 0.55)
    margin-bottom: 24px

  .ministry-text
    h2
      font-family: Raleway, sans-serif
      font-weight: 900
      font-size: clamp(32px, 4vw, 52px)
      line-height: 1.02
      letter-spacing: -0.025em
      margin: 0 0 24px
      color: #fff
      text-transform: lowercase

    p
      font-size: clamp(15px, 1.1vw, 17px)
      line-height: 1.7
      color: rgba(255, 255, 255, 0.78)
      margin: 0
      max-width: 640px

  .ministry-logo
    display: flex
    justify-content: center
    align-items: center

    img
      max-width: 100%
      height: auto
      max-height: 140px
      object-fit: contain

  @media (max-width: 960px)
    .ministry-block
      padding: 80px 0

    .block-container
      padding: 0 28px !important

    .ministry-grid
      grid-template-columns: 1fr
      gap: 48px

    .ministry-logo
      justify-content: flex-start

      img
        max-height: 100px
</style>
